import { render, staticRenderFns } from "./CrowdSelectPannel.vue?vue&type=template&id=04678afe&scoped=true&"
import script from "./CrowdSelectPannel.vue?vue&type=script&lang=js&"
export * from "./CrowdSelectPannel.vue?vue&type=script&lang=js&"
import style0 from "./CrowdSelectPannel.vue?vue&type=style&index=0&id=04678afe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04678afe",
  null
  
)

export default component.exports